import {BASE_TRACK_API_URL} from '@constants/config'
import {apiRequestWithAuth} from '@helpers/query/apiRequestWithAuth'
import {OnShowError} from '@baseTypes/base'
import {IDeviceVideoStream, IVideoStream} from '@containers/video/videoStreams/types'

const BASE_URL_VIDEO_STREAMS = `${BASE_TRACK_API_URL}/v1/accounts`

export const getGetVideoStreamsListApi = async (
	accountId: number,
	onError?: OnShowError
): Promise<IVideoStream[]> => {
	const url = `${BASE_URL_VIDEO_STREAMS}/${accountId}/streams`
	return await apiRequestWithAuth<IVideoStream[]>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
	
}


export const getGetDeviceVideoStreamsListApi = async (
	options: {
		accountId: number
		deviceId: number
		quality?: 'main'
	},
	onError?: OnShowError
): Promise<IDeviceVideoStream[]> => {

	const query = options.quality ? `?quality=${options.quality}` : ''
	const url = `${BASE_URL_VIDEO_STREAMS}/${options.accountId}/devices/${options.deviceId}/streams${query}`
	return await apiRequestWithAuth<IDeviceVideoStream[]>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}

export const deleteStreamApi = async (
	options: {
		accountId: number
		cameraId: string
	},
	onError?: OnShowError
): Promise<void> => {
	const url = `${BASE_URL_VIDEO_STREAMS}/${options.accountId}/cameras/${options.cameraId}/stream`
	return await apiRequestWithAuth<void>({
		url,
		options: {
			method: 'DELETE',
		},
		onError
	})
}
